import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RouteEnum } from '@app/constants/route.enum';

export const networkGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  if (isPlatformBrowser(platformId) && !navigator.onLine) {
    if (state.url.startsWith(RouteEnum.NO_INTERNET)) {
      return true;
    }
    return router.createUrlTree([RouteEnum.NO_INTERNET]);
  }
  return true;
};
